export default __webpack_public_path__ + "static/onsite-15c8177b2087913967bcf4588696c103.webp";